import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditOrderPayload } from '@app-store/slices/subscriptionOrder/edit'

interface TaskAction extends Action {
    payload: IEditOrderPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.orders.edit

function* editOrderSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/subscriptions/orders/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editOrderSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editOrderSagaTask)
}

export default editOrderSaga
